// src/app/services/api.service.ts
import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable, of } from 'rxjs';
import { ApiResponse } from './library_objects.service';

import { environment } from '../../environments/environment';

export interface ApiRequestParams {
  page?: number;
  limit?: number;
  search?: string;
  sortBy?: string[];
  [key: string]: any;
}
@Injectable({
  providedIn: 'root'
})
export class ClientLibraryObjectsSerive {
  private baseUrl: string = `${environment['api_backend']}/api`
  private readonly http = inject(HttpClient);

  constructor() { }

  /**
   * Obtiene una lista de "Client Library Objects" filtrada por los parámetros enviados.
   * @param params Un objeto con los filtros a aplicar.
   * @returns Un Observable con la respuesta de la API.
   */
  getClientLibraryObjectAll(params: ApiRequestParams): Observable<any> {
    let httpParams = new HttpParams();
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const value = params[key];

        if (value !== null && value !== undefined) {

          if (Array.isArray(value)) {
            value.forEach(item => {
              httpParams = httpParams.append(key, item.toString());
            });
          } else {
            httpParams = httpParams.set(key, value.toString());
          }
        }
      }
    }

    return this.http.get<any>(`${this.baseUrl}/client-library-objects/`, { params: httpParams });
  }

  createClientLibraryObject(data: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/client-library-objects/`, data);
  }


  updateClientLibraryObject(id: number, data: any): Observable<any> {
    return this.http.patch<any>(`${this.baseUrl}/client-library-objects/${id}`, data);
  }

}
